<section class="cta-section">
  <div class="cta-section__content">
    <div class="cta-section__text">
      <h2 class="h2" style="color: var(--color-neutral-100);">Regálate un momento para parar y crear</h2>
      <p class="body-m" style="color: var(--color-neutral-100); opacity: 0.9;">
        Una pausa en medio del ritmo diario para reconectar contigo y vivir una experiencia diferente.
        Plazas limitadas para mantener grupos pequeños.
      </p>
      <button class="btn cta-section__btn" (click)="scrollToTalleres()">
        Próximos talleres
      </button>
    </div>
  </div>
</section>
